/** A grey placeholder block, pulsing while data loads (themed like bg-gray-200). */
const Skeleton = ({ className = '' }: { className?: string }) => (
  <div aria-hidden="true" className={`motion-safe:animate-pulse rounded-md bg-gray-200 ${className}`} />
)

export default Skeleton
